import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import MotivoRetrasoEmbarque from './MotivoRetrasoEmbarque';
import ACCESS from '../../../ACCESS.js';

class MotivosAtrasoEmbarques extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'motivo-atraso-embarque/filter', deleteUrl: 'motivos-atraso-embarque/delete', deleteField: 'motivo_nombre', modUrl: '/Catalogo/MotivoAtrasoEmbarque' },
      TableOp.Table('Motivos', [
        { label: 'Clave', id: 'motivo_clave' },
        { label: 'Descripcion', id: 'motivo_nombre' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.CATALOGO_MOTIVOS_ATRASO_EMBARQUE.EDITAR_CATALOGO] },
        { id: 'delete', icon: 'delete', access: [ACCESS.CATALOGO_MOTIVOS_ATRASO_EMBARQUE.ELIMINAR_CATALOGO] },
      ]))
    this.table();
  }

  render() {

    return (
      <div>
        <div>
          {
             
          <MotivoRetrasoEmbarque  onSave={() => {this.table()}}></MotivoRetrasoEmbarque>
        }
        {
           
          <this.TableRender  />
        }
        </div>
      </div>
    )
  }
}

export default withRouter(MotivosAtrasoEmbarques)